/**
 * 项目首页
 */
import React, { useEffect, useState } from 'react';
import styles from './rwdDetail.module.scss';
import icon_collect_task_avatar from '../../static/images_doctor/icon_collect_task_avatar.png';
import icon_collect_quesionnaire from '../../static/images_doctor/icon_collect_quesionnaire.png';
import icon_rwd_follow_evalution from '../../static/images_doctor/icon_rwd_follow_evalution.png';
import icon_rwd_quesionnaire from '../../static/images_doctor/icon_rwd_quesionnaire.png';
import icon_rwd_record from '../../static/images_doctor/icon_rwd_record.png';
import icon_rwd_right_arrow from '../../static/images_doctor/icon_rwd_right_arrow.png';
import icon_rwd_question_circle_fill from '../../static/images_doctor/icon_rwd_question_circle_fill.png';
import camera_blue from '../../static/images_doctor/rwd/camera_blue.png';
import camera_gray from '../../static/images_doctor/rwd/camera_gray.png';
import camera_green from '../../static/images_doctor/rwd/camera_green.png';
import camera_orange from '../../static/images_doctor/rwd/camera_orange.png';
import diskette_blue from '../../static/images_doctor/rwd/diskette_blue.png';
import diskette_gray from '../../static/images_doctor/rwd/diskette_gray.png';
import diskette_green from '../../static/images_doctor/rwd/diskette_green.png';
import diskette_orange from '../../static/images_doctor/rwd/diskette_orange.png';
import eye_blue from '../../static/images_doctor/rwd/eye_blue.png';
import eye_gray from '../../static/images_doctor/rwd/eye_gray.png';
import eye_green from '../../static/images_doctor/rwd/eye_green.png';
import eye_orange from '../../static/images_doctor/rwd/eye_orange.png';
import locked_padloc_oange from '../../static/images_doctor/rwd/locked_padloc_oange.png';
import locked_padlock_blue from '../../static/images_doctor/rwd/locked_padlock_blue.png';
import locked_padlock_gray from '../../static/images_doctor/rwd/locked_padlock_gray.png';
import locked_padlock_green from '../../static/images_doctor/rwd/locked_padlock_green.png';
import snow_blue from '../../static/images_doctor/rwd/snow_blue.png';
import snow_gray from '../../static/images_doctor/rwd/snow_gray.png';
import snow_green from '../../static/images_doctor/rwd/snow_green.png';
import snow_orange from '../../static/images_doctor/rwd/snow_orange.png';
import warning_filled_blue from '../../static/images_doctor/rwd/warning_filled_blue.png';
import warning_filled_gray from '../../static/images_doctor/rwd/warning_filled_gray.png';
import warning_filled_green from '../../static/images_doctor/rwd/warning_filled_green.png';
import warning_filled_orange from '../../static/images_doctor/rwd/warning_filled_orange.png';
import time_to_set from '../../static/images_doctor/rwd/time_to_set.png';
import icon_collect_status_completed from '../../static/images_doctor/rwd/icon_collect_status_completed.png';
import icon_collect_status_no_pass from '../../static/images_doctor/rwd/icon_collect_status_no_pass.png';
import icon_collect_status_no_sign from '../../static/images_doctor/rwd/icon_collect_status_no_sign.png';
import icon_collect_status_pass from '../../static/images_doctor/rwd/icon_collect_status_pass.png';
import icon_collect_status_audit_pass from '../../static/images_doctor/rwd/icon_collect_status_audit_pass.png';
import icon_collect_status_remain_audit from '../../static/images_doctor/rwd/icon_collect_status_remain_audit.png';
import icon_collect_status_ing from '../../static/images_doctor/rwd/icon_collect_status_ing.png';
import icon_collect_status_remain_to_approve from '../../static/images_doctor/rwd/icon_collect_status_remain_to_approve.png';

import { createFromIconfontCN } from '@ant-design/icons';

import { ActivityIndicator, Button, DatePickerView, InputItem, List, Modal, Picker, Toast } from 'antd-mobile';

import icon_rwd_node_complete from '../../static/images_doctor/icon_rwd_node_complete.png';
import icon_rwd_node_ing from '../../static/images_doctor/icon_rwd_node_ing.png';
import moment from 'moment';
import { ApiCore } from '../../api/index';

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_dm1ywqphtbf.js',
});

const api = new ApiCore();

function RwdDetail(props: any) {

    const [subjectsData, setSubjectsData] = useState<any>({});
    const [formData, setFormData] = useState<any>([]);
    const [isMessageFocus, setIsMessageFocus] = useState<any>(false);

    const [subjectCountInfo, setSubjectCountInfo] = useState<any>({ isReady: false });
    const [formCountInfo, setFormCountInfo] = useState<any>({ isReady: false });

    const [hasMessage, setHasMessage] = useState<any>(false);

    //实际访视日期
    const [visitDate, setVisitDate] = useState<any>();
    //实际访视日期选择弹框是否显示
    const [visitDateModalShow, setVisitDateModalShow] = useState<boolean>(false);
    //预约访视日期
    const [appointmentDate, setAppointmentDate] = useState<any>();
    //预约访视日期选择弹框是否显示
    const [appointmentDateModalShow, setAppointmentDateModalShow] = useState<boolean>(false);
    
    const [nodeList, setNodeList] = useState<any>([]);
    const [indicatorCurIndex, setIndicatorCurIndex] = useState(0);

    //设置加载状态
    const [loading, setLoading] = useState(false);
    const [messageActive, setMessageActive] = useState(false);
    const [messageFormData, setMessageFormData] = useState<any>([]);

    useEffect(() => {
        //设置网页title
        document.title = '病例征集';
    }, [])

    useEffect(() => {
        if (props.subjectsData) {
            const _subjectsData = props.subjectsData;
            let _count = 0;
            _subjectsData && (_subjectsData.visits || []).forEach((element: any) => {
                if (element.state === 'Complete') {
                    _count++;
                }
            });
            _subjectsData && _subjectsData.visits && setSubjectCountInfo({
                count: _count,
                total: _subjectsData.visits.length,
                isReady: true
            });
            setSubjectsData(_subjectsData);
            setNodeList(_subjectsData.visits || []);
            if (_subjectsData.visits && _subjectsData.visits) {
                let _currentVisitId = sessionStorage.getItem('CurrentVisitId');
                let _id = 0;
                let _index = 0;
                _subjectsData.visits.some((item: any, index: number)=> {
                    if (item.state !== 'Complete') {
                        _id = item.id;
                        _index = index;
                        return true;
                    }
                })
                // 如果有选过覆盖
                _subjectsData.visits.some((item: any, index: number)=> {
                    if (item.id == _currentVisitId) {
                        _id = item.id;
                        _index = index;
                        return true;
                    }
                })
                setIndicatorCurIndex(_index);
                getFormsById(_id);
            }
            if (_subjectsData && _subjectsData.tasks) {
                let _hasMessage = _subjectsData.tasks.some((val: any) => {
                    if (val.message) {
                        return true;
                    }
                });
                setHasMessage(_hasMessage);
            }
        }
    }, [props.subjectsData])

    useEffect(() => {
        if (props.formData) {
            // console.log('props.formData', props.formData);
            // const _formData = props.formData;
            // let _count = 0;
            // _formData && (_formData.visits || []).forEach((element: any) => {
            //     if (element.state === 'Complete') {
            //         _count++;
            //     }
            // });
            // _subjectsData && _subjectsData.visits && setSubjectCountInfo({
            //     count: _count,
            //     total: _subjectsData.visits.length,
            //     isReady: true
            // });
            // setFormData(_formData);
            // inputState
        }
    }, [props.formData])

    const nodeListActive = (item: any, index: number) => {
        setMessageActive(false);
        setIsMessageFocus(false);
        setIndicatorCurIndex(index);
        getFormsById(item.id)
        sessionStorage.setItem('CurrentVisitId', item.id);
    }

    //当点击了任务按钮
    const onClickTask = (taskType: any) => {
        setMessageActive(true);
        setIndicatorCurIndex(-1);
        // return (e: any) => {
            //清除选中状态
            // if (selectedEle) {
            //     let ele = document.getElementById(selectedEle);
            //     if (ele) {
            //         ele.style.backgroundColor = '#FFFFFF';
            //         ele.style.fontWeight = '400';
            //     }
            // }
            // setSelectedEle(e.currentTarget.id);
            // if (taskType == 'Answer') {
            //     e.currentTarget.style.backgroundColor = '#fae2a2';
            // } else {
            //     e.currentTarget.style.backgroundColor = '#bccef9';
            // }
            // e.currentTarget.style.fontWeight = '700';

            // //保存操作访视状态
            let currentState = {
                type: 'task',
                key: taskType
            }
            sessionStorage.setItem('currentState', JSON.stringify(currentState));
            
            // setLoading(true);
            api.getVisitsByType({ subjectCode: subjectsData.code, type: taskType }).then(res => {
                if (res.code == '0') {
                    setIsMessageFocus(true);
                    setFormData(res.data)
                }
                // setLoading(false);
            })
            // #E7FDE8
        // }
    }

    //选择访视时间
    const switchVisitTime = (item: any) => {
        switch (item.state) {
            case 'Complete':
                return item.visitDate
            case 'Running':
                return item.visitDate
            case 'Lose':
                return item.appointmentDate ? item.appointmentDate : item.planDate
            case 'Wait':
                return item.appointmentDate ? item.appointmentDate : item.planDate
            default:
                break;
        }
    }

    //根据访视id获取表单数据
    const getFormsById = (id: any) => {
        sessionStorage.setItem('eventCode', id)
        let params = {
            id: id
        }
        api.getFormsById(params).then(res => {
            if (res.code == '0') {
                let filterArr = [];
                filterArr.push(res.data)
                setFormData(filterArr)
                // 如果节点下面只有一个表单时，直接渲染
                // let _item = res.data;
                // // if (_item && _item.forms && _item.forms.length === 1) {
                // if (_item && _item.forms && _item.type === 'SingleForm') {
                //     clickForm(_item, _item.forms[0])();
                // }
                let _arr = res.data.forms || [];
                let _count = 0;
                (_arr || []).forEach((element: any) => {
                    if (element.inputState === 'Complete') {
                        _count++;
                    }
                });
                _arr && setFormCountInfo({
                    count: _count,
                    total: _arr.length,
                    isReady: true
                });
            }
            // setLoading(false);
        })
    }

    //处理from中input状态
    const switchFormInputState = (inputState: any) => {
        switch (inputState) {
            case 'Complete':
                return <img src={diskette_blue} alt="" />
            case 'Running':
                return <img src={diskette_green} alt="" />
            case 'Question':
            case 'Answer':
                return <img src={diskette_orange} alt="" />
            case 'Wait':
                return <img src={diskette_gray} alt="" />
            default:
                break;
        }
    }

    //处理from中check状态 系统质疑
    const switchFormCheckState = (checkState: any) => {
        switch (checkState) {
            case 'Complete':
                return <img src={warning_filled_blue} alt="" />
            case 'Running':
                return <img src={warning_filled_green} alt="" />
            case 'Question':
            case 'Answer':
                return <img src={warning_filled_orange} alt="" />
            case 'Wait':
                return <img src={warning_filled_gray} alt="" />
            default:
                break;
        }
    }

    //处理from中question状态 人工质疑
    const switchFormQuestionState = (questionState: any) => {
        switch (questionState) {
            case 'Complete':
                return <img src={eye_blue} alt="" />
            case 'Running':
                return <img src={eye_green} alt="" />
            case 'Question':
            case 'Answer':
                return <img src={eye_orange} alt="" />
            case 'Wait':
                return <img src={eye_gray} alt="" />
            default:
                break;
        }
    }

    //处理from中Examine状态
    const switchFormExamineState = (examineState: any) => {
        switch (examineState) {
            case 'Complete':
                return <IconFont type="iconExamine_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconExamine_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconExamine_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconExamine_Question"></IconFont>
            case 'Answer':
                return <IconFont type="iconExamine_Answer"></IconFont>
            default:
                break;
        }
    }

    //处理from中Freeze状态
    const switchFormFreezeState = (freezeState: any) => {
        switch (freezeState) {
            case 'Complete':
                return <img src={snow_blue} alt="" />
            case 'Running':
                return <img src={snow_green} alt="" />
            case 'Question':
            case 'Answer':
                return <img src={snow_orange} alt="" />
            case 'Wait':
                return <img src={snow_gray} alt="" />
            default:
                break;
        }
    }
    //处理from中Autograph状态
    const switchFormAutographState = (autographState: any) => {
        switch (autographState) {
            case 'Complete':
                return <IconFont type="iconAutograph_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconAutograph_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconAutograph_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理from中Lock状态
    const switchFormLockState = (lockState: any) => {
        switch (lockState) {
            case 'Complete':
                return <img src={locked_padlock_blue} alt="" />
            case 'Running':
                return <img src={locked_padlock_green} alt="" />
            case 'Question':
            case 'Answer':
                return <img src={locked_padloc_oange} alt="" />
            case 'Wait':
                return <img src={locked_padlock_gray} alt="" />
            default:
                break;
        }
    }

    //处理ocr录入状态
    const switchFormOcrState = (ocrState: any) => {
        switch (ocrState) {
                case 'Complete':
                    return <img src={camera_blue} alt="" />
                case 'Running':
                    return <img src={camera_green} alt="" />
                case 'Question':
                case 'Answer':
                    return <img src={camera_orange} alt="" />
                case 'Wait':
                    return <img src={camera_gray} alt="" />
                default:
                    break;
        }
    }

    //点击表单
    const clickForm = (item: any, formItem: any) => {
        props.clickForm && props.clickForm(item, formItem)();
    }

    //当点击实际访视时间修改按钮
    const onClickVisitDateModify = (form: any) => {
        return () => {
            if (form.visitDate) {
                setVisitDate(new Date(form.visitDate))
            }
            else {
                setVisitDate(new Date())
            }
            setVisitDateModalShow(true);
        }
    }

    //当点击预约访视时间修改按钮时
    const onClickAppointmentDateDateModify = (form: any) => {
        return () => {
            if (form.appointmentDate) {
                setAppointmentDate(new Date(form.appointmentDate))
            }
            else {
                setAppointmentDate(new Date())
            }
            setAppointmentDateModalShow(true);
        }
    }

    //当实际访视时间修改时
    const onVisitDateModify = (form: any) => {
        let params = {
            visitDate: moment(visitDate).format('YYYY-MM-DD'),
            visitId: form.id
        }
        setLoading(true);
        api.modifyVisitDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                setVisitDateModalShow(false);
                //更新数据
                getFormsById(form.id);
                // props.initData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
            setLoading(false);

        })
    }


    //当预约访视时间修改时
    const onAppointmentDateModify = (form: any) => {
        let params = {
            appointmentDate: moment(appointmentDate).format('YYYY-MM-DD'),
            visitId: form.id
        }
        setLoading(true);
        api.modifyAppointmentDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                setAppointmentDateModalShow(false);
                //更新数据
                getFormsById(form.id);
                // props.initData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
            setLoading(false);
        })
    }

    const statusToImgRender = () => {
        if (subjectsData.auditState) {
            if (subjectsData.auditState === 'Wait') {
                return <img src={icon_collect_status_remain_audit} alt="" />
            } else if (subjectsData.auditState === 'Pass') {
                return <img src={icon_collect_status_audit_pass} alt="" />
            } else if (subjectsData.auditState === 'Fail') {
                return <img src={icon_collect_status_no_pass} alt="" />
            }
        } else {
            if (subjectsData.state === 'Init') {
                return <img src={icon_collect_status_remain_to_approve} alt="" />
            } else if (subjectsData.state === 'Active') {
                return <img src={icon_collect_status_ing} alt="" />
            } else if (subjectsData.state === 'Finish' && subjectsData.signState === 'Wait') {
                return <img src={icon_collect_status_no_sign} alt="" />
            } else if (subjectsData.state === 'Finish' ) {
                return <img src={icon_collect_status_completed} alt="" />
            }
        }
        return <></>;
    }

    const activBorder = (val: any, key: number) => {
        if (key !== indicatorCurIndex) {
            return styles.followup_card_un_active
        }
        let bgClass = '';
        switch (val.state) {
            case 'Running':
                bgClass =  styles.followup_card_ing_active;
                break;
            case 'Complete':
                bgClass = styles.followup_card_complete_active;
                break;
            case 'Question':
                bgClass = styles.followup_card_question_active;
                break;
            default:
                bgClass = styles.followup_card_others_active;
                break;
        }
        return bgClass;
    }

    return (
        <div className={styles.caseCollectContent}>
            <div className={styles.head}>
                <div className={styles.top}>
                    <div className={styles.left}>
                        <img src={icon_collect_task_avatar} alt="" />
                    </div>
                    <div className={styles.middle}>
                        <div className={styles.middle_top}>
                            <span className={styles.code}>
                                {subjectsData.code}
                            </span>
                            {
                                subjectsData.createUser &&
                                <span className={styles.name}>
                                    {subjectsData.createUser}
                                </span>
                           }
                        </div>
                        <div className={styles.middle_bottom}>
                            {subjectsData.projectName}
                        </div>
                    </div>
                    {
                        <div className={styles.right}>
                            {
                                statusToImgRender()
                            }
                        </div>
                    }
                </div>
                {
                    subjectsData.tasks && subjectsData.tasks.map((val: any, index: number) => ( 
                    val.message ?             
                    <div key={index} className={`${styles.message} ${messageActive ? styles.running_message: styles.warning_message}`} onClick={() => { onClickTask(val.type) }}>
                        <div className={styles.content}>
                            <div className={styles.look_text}>{val.message}</div>
                            <div className={styles.look_btn}>查看</div>
                        </div>
                    </div>
                    :
                    null
                    ))
                }

            </div>

            <div className={`${styles.middle_content} ${hasMessage ? styles.content_has_message_gap : styles.content_no_message_gap}`}> 
                <div className={`${styles.body_head} ${styles.card_header}`}>
                    <div className={styles.title}>访视节点</div>
                    <div></div>
                    {
                        subjectCountInfo.isReady &&
                    <div className={styles.progress}>

                            <span className={styles.current}>{subjectCountInfo.count}</span>/{subjectCountInfo.total}
                    </div>
                    }
                </div>
                <div className={`${styles.followup_card_container}`}>
                    {
                        nodeList && nodeList.map((val: any, key: number) => (
                            <div key={key} 
                                className={`${
                                    nodeList[key].state == 'Running' ? styles.followup_card_ing : nodeList[key].state == 'Complete' ? styles.followup_card_completed  : (nodeList[key].state == 'Question' || nodeList[key].state == 'Answer') ? styles.followup_card_question : ''
                                } ${
                                    activBorder(val, key)
                                }`} 
                                onClick={ () => { nodeListActive(val, key) }}>
                                <div className={`${styles.followup_card_title}`}>{val.name}</div>
                                <div className={`${styles.followup_card_desc}`}>{switchVisitTime(val)}</div>  
                            </div>
                        ))
                    }
                </div>
                <div className={`${styles.followup_indicator}`}>
                    {
                        nodeList && nodeList.map((val: any, key: number) => (
                            <div key={key} className={`${key === indicatorCurIndex ? styles.followup_indicator_active : nodeList[key].state == 'Complete' ? styles.followup_indicator_already_active : ''}`}></div>
                        ))
                    }
                </div>
                {
                    ((formData && formData.length == 1 && (formData[0].type === 'PlanVisit' || formData[0].type === 'StatelessVisit'))) ? 
                    <div className={`${styles.line_gap}`}>
                    </div>
                    :
                    null
                }

                {/* 预约访视时间 */}
                {
                    formData && formData.length > 0 && formData.map((item: any, index: any) => (
                        <>
                            {
                            ((formData && formData.length == 1 && (formData[0].type === 'PlanVisit' || formData[0].type === 'StatelessVisit'))) ?
                            <div key={index}>
                                <div className={`${styles.bottom_time_intro}`}>
                                    <div> 
                                        <div>计划访视时间</div>    
                                        <div className={styles.plan_time}>
                                        {
                                            item.planDate ? item.planDate : 
                                            <img src={time_to_set} />
                                        }
                                        {/* 暂无 */}
                                        </div>    
                                    </div>
                                    {
                                        item.state !== 'Wait' ? 
                                        <div>
                                            <div>预约访视时间</div>    
                                            <div>
                                                {
                                                    item.appointmentDate ? item.appointmentDate : '未预约'
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div  onClick={onClickAppointmentDateDateModify(item)}>
                                            <div>预约访视时间</div>    
                                            <div>
                                                {
                                                    item.appointmentDate ? item.appointmentDate : '未预约'
                                                }
                                                <IconFont type="iconModify"></IconFont>
                                            </div>   
                                        </div>
                                    }
                                    {
                                        item.state === 'Complete' ?
                                        <div>
                                            <div>实际访视时间</div>    
                                            <div className={styles.infact_time}>
                                                {
                                                    item.visitDate ? item.visitDate : <img src={time_to_set} alt="" />
                                                }
                                            </div>   
                                        </div>
                                        :
                                        <div onClick={onClickVisitDateModify(item)}>
                                            <div>实际访视时间</div>    
                                            <div>
                                            {
                                                item.visitDate ? item.visitDate : '设置'
                                            }
                                            <IconFont type="iconModify"></IconFont>
                                            </div>   
                                        </div>
                                    }
                                </div>
                                {/* 设置预约访视时间弹框 */}
                                <Modal
                                    visible={appointmentDateModalShow}
                                    transparent
                                    maskClosable={false}
                                    onClose={() => { setAppointmentDateModalShow(false) }}
                                    title="设置预约访视时间"
                                    footer={[{ text: '取消', onPress: () => { setAppointmentDateModalShow(false); } }, { text: '确认', onPress: () => { onAppointmentDateModify(item) } }]}
                                >
                                    <DatePickerView
                                        mode="date"
                                        value={appointmentDate}
                                        onChange={(value) => { setAppointmentDate(value) }}
                                    />
                                </Modal>
                                {/* 设置实际访视时间弹框 */}
                                <Modal
                                    visible={visitDateModalShow}
                                    transparent
                                    maskClosable={false}
                                    onClose={() => { setVisitDateModalShow(false) }}
                                    title="设置实际访视时间"
                                    footer={[{ text: '取消', onPress: () => { setVisitDateModalShow(false); } }, { text: '确认', onPress: () => { onVisitDateModify(item) } }]}
                                >
                                    <DatePickerView
                                        mode="date"
                                        value={visitDate}
                                        onChange={(value) => { setVisitDate(value) }}
                                    />
                                </Modal>
                        </div>
                        :
                        null
                        }
                        </>
                    ))

                }
            </div>

            <div className={styles.body}>
                
                {/* <img className={styles.img_top_inlay} src={icon_collect_bookmark} alt="" /> */}
                
                <div className={styles.body_head}>
                    <div className={styles.title}>{formData[0] ? formData[0].name : ''}</div>
                    {
                        formCountInfo.isReady &&
                        <div className={styles.progress}>
                            <span className={styles.current}>{formCountInfo.count}</span>/{formCountInfo.total}
                        </div>
                    }
                </div>
                {
                    formData && formData.length > 0 && formData.map((item: any) => (<>
                        {
                            item.forms.map((val: any, index: number) => (
                                <div key={index} className={`${styles.outer_wrap}`} onClick={() => { clickForm(item, val) }} >
                                    <img className={`${styles.img_left_inlay} ${val.inputState === 'Complete' ? styles.blue : val.inputState === 'Running' ? styles.green : (val.inputState === 'Question' || val.inputState === 'Answer') ? styles.orange : styles.gray}`} 
                                         src={val.inputState === 'Complete' ? icon_rwd_quesionnaire : val.inputState === 'Running' ? icon_rwd_record : (val.inputState === 'Question' || val.inputState === 'Answer') ? icon_rwd_follow_evalution : icon_rwd_quesionnaire} alt="" />
                                    <div className={styles.outer}>
                                        <div className={styles.inner}>
                                            <div className={`${styles.title}`}>{val.name}</div>
                                            <div className={`${styles.desc} ${styles.blue_desc}`}>

                                                        {
                                                            switchFormOcrState(val.ocrState)
                                                        }
                                                        {
                                                            switchFormInputState(val.inputState)
                                                        }
                                                        {
                                                            switchFormCheckState(val.checkState)
                                                        }
                                                        {
                                                            switchFormQuestionState(val.questionState)
                                                        }
                                                        {
                                                            // switchFormExamineState(val.examineState)
                                                        }
                                                        {
                                                            switchFormFreezeState(val.freezeState)
                                                        }
                                                        {
                                                            // switchFormAutographState(val.autographState)
                                                        }
                                                        {
                                                            switchFormLockState(val.lockState)
                                                        }
                                                {/* <img src={icon_rwd_item_camera} alt="" />
                                                <img src={icon_rwd_item_diskette} alt="" />
                                                <img src={icon_rwd_item_warning_filled} alt="" />
                                                <img src={icon_rwd_item_eye} alt="" />
                                                <img src={icon_rwd_item_snow} alt="" />
                                                <img src={icon_rwd_item_locked_padlock} alt="" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${styles.arrow} ${val.inputState === 'Complete' ? styles.arrow_blue : val.inputState === 'Running' ? styles.arrow_green : (val.inputState === 'Question' || val.inputState === 'Answer') ? styles.arrow_orange : styles.arrow_gray}`}> 
                                        <img src={icon_rwd_right_arrow} alt="" />
                                    </div>
                                </div>))
                        }
                    </>))
                }

                {/* <div className={`${styles.outer_wrap} ${styles.bg_blue}`}>
                    <img className={`${styles.img_left_inlay} ${styles.blue}`} src={icon_rwd_quesionnaire} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title}`}>基本信息</div>
                            <div className={`${styles.desc} ${styles.blue_desc}`}>
                                <img src={icon_rwd_item_camera} alt="" />
                                <img src={icon_rwd_item_diskette} alt="" />
                                <img src={icon_rwd_item_warning_filled} alt="" />
                                <img src={icon_rwd_item_eye} alt="" />
                                <img src={icon_rwd_item_snow} alt="" />
                                <img src={icon_rwd_item_locked_padlock} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.arrow} ${styles.arrow_blue}`}>
                        <img src={icon_rwd_right_arrow} alt="" />
                    </div>
                </div>

                <div className={`${styles.outer_wrap} ${styles.bg_orange}`}>
                    <img className={`${styles.img_left_inlay} ${styles.blue}`} src={icon_rwd_quesionnaire} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title}`}>{'治疗效果评估&生存随访'}</div>
                            <div className={`${styles.desc}`}>
                                <img src={icon_rwd_item_camera} alt="" />
                                <img src={icon_rwd_item_diskette} alt="" />
                                <img src={icon_rwd_item_warning_filled} alt="" />
                                <img src={icon_rwd_item_eye} alt="" />
                                <img src={icon_rwd_item_snow} alt="" />
                                <img src={icon_rwd_item_locked_padlock} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.arrow} ${styles.arrow_blue}`}>
                        <img src={icon_rwd_right_arrow} alt="" />
                    </div>
                </div>

                <div className={`${styles.outer_wrap} ${styles.bg_green}`}>
                    <img className={`${styles.img_left_inlay} ${styles.green}`} src={icon_rwd_record} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title}`}>用药信息</div>
                            <div className={`${styles.desc} ${styles.green_desc}`}>
                                <img src={icon_rwd_item_camera} alt="" />
                                <img src={icon_rwd_item_diskette} alt="" />
                                <img src={icon_rwd_item_warning_filled} alt="" />
                                <img src={icon_rwd_item_eye} alt="" />
                                <img src={icon_rwd_item_snow} alt="" />
                                <img src={icon_rwd_item_locked_padlock} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.arrow} ${styles.arrow_green}`}>
                        <img src={icon_rwd_right_arrow} alt="" />
                    </div>
                </div>

                <div className={`${styles.outer_wrap} ${styles.bg_blue}`}>
                    <img className={`${styles.img_left_inlay} ${styles.orange}`} src={icon_rwd_follow_evalution} alt="" />
                    <div className={styles.outer}>
                        <div className={styles.inner}>
                            <div className={`${styles.title}`}>诊断信息</div>
                            <div className={`${styles.desc} ${styles.blue_desc}`}>
                                <img src={icon_rwd_item_camera} alt="" />
                                <img src={icon_rwd_item_diskette} alt="" />
                                <img src={icon_rwd_item_warning_filled} alt="" />
                                <img src={icon_rwd_item_eye} alt="" />
                                <img src={icon_rwd_item_snow} alt="" />
                                <img src={icon_rwd_item_locked_padlock} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.arrow} ${styles.arrow_orange}`}>
                        <img src={icon_rwd_right_arrow} alt="" />
                    </div>
                </div> */}

                {/* todo */}
                {/* <div>
                    <div className={`${styles.bottom_tip}`}>
                        <div></div>
                        <img src={icon_rwd_question_circle_fill} alt="" />
                        <span className={`${styles.tip_text}`}>点击查看表单图例说明</span>
                        <div></div>
                    </div>
                </div> */}

            </div>

        </div>
    )
}

export default RwdDetail;